import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const dpiCategoryLocaleModule: LocaleModule = {
  name: "dpiCategory",
  messages: { en: en, it: it },
};
